import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "status-content" }
const _hoisted_3 = { class: "status-options" }
const _hoisted_4 = { class: "status-grid" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "status-badge" }
const _hoisted_7 = {
  key: 0,
  class: "current-indicator"
}
const _hoisted_8 = {
  key: 1,
  class: "checkmark"
}
const _hoisted_9 = { class: "modal-actions" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-overlay",
        onClick: _withModifiers($setup.closeModal, ["self"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("div", { class: "modal-title" }, "Select Source")
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label" }, "Select Source", -1)),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.LeadSourceEnum, (source, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["status-option", { selected: $setup.selectedSource === source, 'current disabled': $props.currentSource === source }]),
                    key: key,
                    onClick: ($event: any) => ($setup.selectSource(source))
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(source), 1),
                    ($props.currentSource === source)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Current"))
                      : _createCommentVNode("", true),
                    ($setup.selectedSource === source)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "✓"))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_5))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn cancel",
              onClick: $setup.closeModal
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn primary v2",
              onClick: $setup.confirmSource,
              disabled: !$setup.selectedSource || $setup.selectedSource === $props.currentSource
            }, "Done", 8, _hoisted_10)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}